import { types } from 'mobx-state-tree';
import _ from 'lodash';

import ChildProduct from './ChildProduct';
import ProductProperty from './ProductProperty';

const ProductMulti = types
  .model('ProductMulti', {
    properties: types.array(ProductProperty),
    children: types.array(types.late(ChildProduct))
  })
  .actions((self) => {
    return {
      setChildren(children) {
        self.children = children;
      }
    };
  })
  .views((self) => {
    return {
      findChildWithProperties(propertyElementMap) {
        return self.children.find((childProduct) =>
          childProduct.hasProperties(propertyElementMap)
        );
      },
      findChild(activeProductId) {
        return self.children.find((child) => child.id === activeProductId);
      },
      getChildIdentifiers() {
        return self.children.map((child) => child.id);
      },
      getChildWithBestDiscount() {
        return _.maxBy(self.children, 'price_info.discount_percentage');
      },
      getMinMaxPrice(withTax) {
        const getPrice = (childProduct) => {
          return childProduct.price_info
            ? childProduct.price_info.getPrice(withTax)
            : () => {};
        };
        const minProduct = _.minBy(self.children, getPrice);
        const maxProduct = _.maxBy(self.children, getPrice);
        return {
          min: minProduct ? minProduct.price_info : 0.0,
          max: maxProduct ? maxProduct.price_info : 0.0
        };
      },
      getPropertyElementStatus(propertyElementMap) {
        let status = {
          exists: false,
          available: false
        };
        // Check if we have any children with the given properties and if they are available
        const matchingChildren = self.children.filter((currentChild) =>
          currentChild.hasProperties(propertyElementMap)
        );
        if (matchingChildren.length > 0) {
          status.exists = true;
        }
        status.available = matchingChildren.some(
          (currentChild) => currentChild.free_quantity > 0
        );
        return status;
      },
      getSecondaryPriceRange(withTax) {
        return self.getMinMaxPrice(withTax);
      },
      get priceRange() {
        return self.getMinMaxPrice();
      }
    };
  });

export default ProductMulti;



// WEBPACK FOOTER //
// ./src/models/ProductMulti.js